exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rednao.button.action{\r\n    color:black !important;\r\n    padding:0 10px;\r\n    border-color: #ccc;\r\n}\r\n\r\n.rednao.button.action.ladda-button[data-style=expand-right][data-loading]{\r\n    padding-right: 56px;\r\n}\r\n\r\n/*\r\n.rednao .ladda-button:disabled{\r\n    transition: none !important;\r\n}\r\n\r\n */", ""]);

// exports
